import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    id = '',
    name = '',
    orgType = 0,
    qq = '',
    email = '',
    contactPer = '',
    contactTel = '',
    mobile = '',
    province = '',
    city = '',
    county = '',
    address = '',
    industryId = '',
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.org.saveMyOrg, {
        id,
        name,
        orgType,
        qq,
        email,
        mobile,
        contactPer,
        contactTel,
        province,
        city,
        county,
        address,
        industryId,
    }, options);
    if (error) return { error, status };
    return content || {};
};
